import { Outlet } from "react-router";
import { Sidebar } from "./Sidebar";
import { DialogRouter } from "@/components/dialogs/DialogRouter";

export function AppLayout() {
  return (
    <div className="h-screen bg-background">
      <Sidebar />
      <main className="ml-0 md:ml-16 h-screen">
        <Outlet />
      </main>
      <DialogRouter />
    </div>
  );
}
